import PropTypes from "prop-types";

export const baseIconButtonPropTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  isDisabled: PropTypes.bool,
  isOutlineIcon: PropTypes.bool,
};
